export default __webpack_public_path__ + "static/elizabethSCA-9703bca2260bae84e8c4bbac469bbc56.webp";